var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index",style:({
  transform: ("rotate(" + (_vm.verticalVisible ? 0 : 270) + "deg) scale(1,1)"),
  height: ("" + (_vm.verticalVisible ? 'auto' : '100vmin')),
  'transform- origin': 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  'touch-action': ("" + (_vm.verticalVisible ? 'pan-y' : 'pan-x'))
}),attrs:{"id":"app"}},[(_vm.showType === 'start')?_c('Start',{attrs:{"verticalVisible":_vm.verticalVisible,"playing":_vm.playing},on:{"playAudio":_vm.playAudio,"endAudio":_vm.endAudio,"fullClick":_vm.fullClick}}):_vm._e(),_vm._v(" "),(_vm.showType === 'index')?_c('Index',{on:{"startClick":_vm.startClick}}):_vm._e(),_vm._v(" "),(_vm.showType === 'before')?_c('BeforeStart',{on:{"startClick":_vm.startClick}}):_vm._e(),_vm._v(" "),_c('audio',{ref:"dradio",staticClass:"mp3",attrs:{"id":"d","autoplay":"","loop":"","src":_vm.music}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbe47cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 